import { render, staticRenderFns } from "./ProfessionalComponent.vue?vue&type=template&id=035b9f21&scoped=true&"
import script from "./ProfessionalComponent.vue?vue&type=script&lang=js&"
export * from "./ProfessionalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b9f21",
  null
  
)

export default component.exports